import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getStates } from "./Axios";

const StateSelect = props => {
  const [states, setStates] = useState([]);

  const handleChange = selectedOption => {
    props.handleChange(selectedOption, "state");
  };

  useEffect(() => {
    getStates((response) => {
      if (response && response.data) {
        const newStates = response.data.map((state) => ({
          value: state.id,
          label: state.name,
          uniqueIdentifier: state.unique_identifier,
        }));
        setStates(newStates);
      }
    });
  }, []);

  return (
    <Select
      inputId="trabajando-area-search"
      onChange={handleChange}
      options={states}
      placeholder="Buscar y seleccionar una región"
      value={
        states.find(
          (option) => option.value === props.value?.value
        ) || null
      }
      getOptionLabel={(e) => `${e.label}`}
      filterOption={(option, input) => {
        const searchTerm = input.toLowerCase();
        const { label } = option.data;
        return (
          label.toLowerCase().includes(searchTerm)
        );
      }}
      isSearchable={true}
    />
  );
};

export default StateSelect;

